import { getProjectStatistics } from "../../../../apis/impact-report/report";
import useFetchData from "../../../../hooks/useFetchData";
import VerticalBarChart from "../../../../ui/VerticalBarChart";
import Loader from "../../../../ui/Loader";
import { useFilters } from "../../../../contexts/FiltersContext";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";


const data = [
  { name: 'No Poverty', numberOfSubmissions: 42 },
  { name: 'Zero Hunger', numberOfSubmissions: 38 },
  { name: 'Good Health and Well-being', numberOfSubmissions: 56 },
];

const COLORS = ['var(--barFirst-color)', 'var(--barSecond-color)', 'var(--barThird-color)'];

const SDGsTab = ({projectId,imageGenerationTimestamp}) => {
  const { selectedPrimary, setFilterOptions } = useFilters()
  const { loading, response, error } = useFetchData(
    getProjectStatistics,
    [projectId,"SDG_WISE_BOUNTY_COUNT",imageGenerationTimestamp,""],
    [projectId,"SDG_WISE_BOUNTY_COUNT",imageGenerationTimestamp,""]
  );

  useEffect(()=>{
    if (!loading && response) {
      const list = response?.sdgWiseBountyCount?.map(i=>i?.SDG).filter(Boolean) || []
      setFilterOptions({ label: 'SDGs', options: list })
    }
  },[loading, response, setFilterOptions])

  const transformedData = response?.sdgWiseBountyCount?.map(item => ({
    name: item.SDG,
    value: item.bountyCount
  }))?.sort((a, b) => b?.value - a?.value) || [];
console.log(transformedData,"this is sdgs transformed")
  const allSelected = !selectedPrimary?.length || selectedPrimary.includes('All')
  const filteredData = allSelected ? transformedData : transformedData.filter(d => selectedPrimary.includes(d.name))

  if (loading) return  <div className='w-full h-[23.9375rem] flex pt-11 justify-center '  ><Loader/></div> ;
    
  if(filteredData?.length === 0) return <div className="w-full h-[23.9375rem] flex items-center justify-center text-gray-500">No data available</div>; 

  return (
    <VerticalBarChart
      data={filteredData}
      xAxisLabel="SDGs"
      yAxisLabel="No. of Activities"
      barSize={40}
      visibleBars={17}
      height={500}
      showReferenceLine={true}
      referenceLineValue={50}
      domain={[0, 100]}
      ticks={[0, 20, 40, 60, 80, 100]}
    />
  );
};

export default SDGsTab;